/**
 * @fileoverview POST handler for the "/apps/:app_group_id/initialize_csv_import" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdInitializeCsvImportCacheKeys } from "./constants";
import type { PostAppsAppGroupIdInitializeCsvImportProps, InitializeCsvImportResult } from "./types";

export const postInitializeCsvImport = reactQueryMutationAdapter(
  appsAppGroupIdInitializeCsvImportCacheKeys,
  (props: PostAppsAppGroupIdInitializeCsvImportProps): Promise<InitializeCsvImportResult> => {
    // manipulate props here as needed {  }

    return fetch(
      `/apps/${props.appGroupId}/initialize_csv_import`,
      "POST",
      props,
      {},
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
